














































import Vue from 'vue'
import Component from 'vue-class-component'
import Multiselect from 'vue-multiselect'
import '@/components/inputsV2/styles/MultiSelectV2.scss'
import Status from '@/components/statuses/Status.vue'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import {
  UnassignedPccDepositsStatsByUsername
} from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

type UserPccDepositsOption = {
  key: string,
  value: string,
  content: UnassignedPccDepositsStatsByUsername
}

@Component({
  components: {
    Multiselect,
    Status,
    LoaderWrapper,
  },
})
export default class AssignPccUserDeposits extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  localOptions: UserPccDepositsOption[] = []
  localValue: UserPccDepositsOption[] = []
  pccDepositsByUser: UnassignedPccDepositsStatsByUsername[] = []
  isLoading = false

  get depositsByPccUserOptions (): UserPccDepositsOption[] {
    return this.pccDepositsByUser.map(({ username, depositsCount }) => {
        return {
          key: username,
          value: username,
          content: {
            username,
            depositsCount,
          }
        }
      })
  }

  async getDepositsByPccUser () {
    this.pccDepositsByUser = await this.paymentsModuleInstance.getUnassignedPccDepositsStatsByUsername() || []
  }

  async assignDeposits () {
    this.isLoading = true
    await this.paymentsModuleInstance.assignPccDepositsByPccUsername(this.localValue[0].value)
    this.isLoading = false
    if (this.depositsByPccUserOptions.length === 1) {
      this.$emit('close')
    }
    this.$emit('reload')
    await this.getDepositsByPccUser()
  }

  filterBySearch (searchQuery: string) {
    this.localOptions = this.depositsByPccUserOptions.filter(u => u.content.username.toLowerCase().includes(searchQuery.toLowerCase()))
  }

  async mounted () {
    this.isLoading = true
    await this.getDepositsByPccUser()
    this.isLoading = false
    this.localOptions = this.depositsByPccUserOptions
    if (this.$refs.multiselect) {
      (this.$refs.multiselect as any).activate()
    }
  }
}
